/* ============================================
   AANYA Frequently Bought Together
   Adds the selected set to the cart in a single
   request, then opens the cart drawer (or /cart).
   ============================================ */

(function () {
  'use strict';

  function formatMoney(cents) {
    try {
      return '₹' + Number(cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    } catch (e) {
      return '₹' + cents;
    }
  }

  function init(root) {
    var form = root.querySelector('[data-fbt-form]');
    var checks = Array.prototype.slice.call(root.querySelectorAll('[data-fbt-check]'));
    var totalEl = root.querySelector('[data-fbt-total]');
    var addBtn = root.querySelector('[data-fbt-add]');
    var errorEl = root.querySelector('[data-fbt-error]');
    var routes = window.routes || {};

    function setError(message) {
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.removeAttribute('hidden');
      } else {
        errorEl.setAttribute('hidden', '');
      }
    }

    function updateTotal() {
      var total = 0;
      checks.forEach(function (c) {
        if (c.checked) total += parseInt(c.dataset.price || '0', 10);
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (addBtn) {
        var count = checks.filter(function (c) { return c.checked; }).length;
        addBtn.textContent = count ? 'Add Selected to Bag (' + count + ')' : 'Add Selected to Bag';
        addBtn.setAttribute('aria-disabled', count ? 'false' : 'true');
      }
    }

    function restoreButton() {
      if (!addBtn) return;
      addBtn.classList.remove('loading');
      var count = checks.filter(function (c) { return c.checked; }).length;
      addBtn.textContent = count ? 'Add Selected to Bag (' + count + ')' : 'Add Selected to Bag';
      addBtn.setAttribute('aria-disabled', count ? 'false' : 'true');
    }

    checks.forEach(function (c) {
      c.addEventListener('change', function () {
        setError('');
        updateTotal();
      });
    });

    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        setError('');

        var selected = checks.filter(function (c) { return c.checked; });
        if (!selected.length) return;

        var formData = new FormData();
        selected.forEach(function (c) {
          formData.append('items[][id]', c.value);
          formData.append('items[][quantity]', '1');
        });

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          formData.append('sections_url', window.location.pathname);
        }

        if (addBtn) {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.classList.add('loading');
          addBtn.textContent = 'Adding…';
        }

        fetch(routes.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: formData,
        })
          .then(function (response) { return response.json(); })
          .then(function (result) {
            if (result.status) {
              var message =
                (result.description && result.description.replace(/<[^>]*>/g, '').trim()) ||
                result.message ||
                'Could not add items to your bag.';
              setError(message);
              restoreButton();
              return;
            }

            if (typeof window.publish === 'function') {
              window.publish('cart-update', {
                source: 'aanya-fbt',
                cartData: typeof result.sections !== 'undefined' ? result : undefined,
              });
            }

            var drawerAfter = document.querySelector('cart-drawer');
            if (drawerAfter && typeof drawerAfter.renderContents === 'function') {
              drawerAfter.renderContents(result);
            } else {
              window.location = routes.cart_url || '/cart';
            }
          })
          .catch(function (err) {
            console.error('[AANYA FBT]', err);
            setError('Something went wrong. Please try again.');
            restoreButton();
          });
      });
    }

    updateTotal();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-fbt-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  });
})();